import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, OnDestroy} from '@angular/core';
import { DragDropDirectiveService } from './drag-drop-directive.service';
import { Subscription } from 'rxjs/Subscription';
export class DragDirective implements OnDestroy{
  
  draggedItem:Object;
  
  cssHighlight:string;
  
  releaseDrop:EventEmitter<any> = new EventEmitter();
  
  startDrag:EventEmitter<any> = new EventEmitter();
private highlighted:boolean = false;
private dropSubscription:Subscription;
/**
 * @param {?} el
 * @param {?} dragDropDirectiveService
 */
constructor(
private el: ElementRef,
private dragDropDirectiveService: DragDropDirectiveService
   ) {
  	this.el.nativeElement.draggable='true';
  }
/**
 * @return {?}
 */
onMouseEnter() {
    this.highlight();
  }
/**
 * @return {?}
 */
onMouseOut(){
  	this.highlight();
  }
/**
 * @param {?} event
 * @return {?}
 */
onDragStart(event:any){
    // html draggable will not transfer an object, so we stringify it
    let /** @type {?} */ transferObject = { object: this.draggedItem, id: 'draggedItemID-' + new Date().getTime()}
    let /** @type {?} */ transferObjectString = JSON.stringify(transferObject);
    event.dataTransfer.setData("text", transferObjectString);
    this.dragDropDirectiveService.setDragItem(this.draggedItem);
    this.dropSubscription = this.dragDropDirectiveService.getDropItem().subscribe(
      item => {
        this.emitDraggedItem(this.draggedItem);
      }
    );
    this.startDrag.emit(this.draggedItem);
  }
/**
 * @return {?}
 */
onDragEnd(){
    if (typeof this.dropSubscription !== 'undefined'){
      this.dropSubscription.unsubscribe();
    }
  }
/**
 * @return {?}
 */
ngOnDestroy(){
    if (typeof this.dropSubscription !== 'undefined') {
      this.dropSubscription.unsubscribe();
    }
  }
/**
 * @param {?} item
 * @return {?}
 */
private emitDraggedItem(item){
    this.releaseDrop.emit(item);
    this.dropSubscription.unsubscribe();
  }
/**
 * @return {?}
 */
private highlight(){
    if (this.cssHighlight){
      if (!this.highlighted){
        this.el.nativeElement.classList.add(this.cssHighlight);
      } else {
        this.el.nativeElement.classList.remove(this.cssHighlight);
      }
    }
    this.highlighted = !this.highlighted;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[dragDirective]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DragDropDirectiveService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'draggedItem': [{ type: Input, args: ['dragDirective', ] },],
'cssHighlight': [{ type: Input, args: ['dragHightlight', ] },],
'releaseDrop': [{ type: Output },],
'startDrag': [{ type: Output },],
'onMouseEnter': [{ type: HostListener, args: ['mouseenter', ] },],
'onMouseOut': [{ type: HostListener, args: ['mouseleave', ] },],
'onDragStart': [{ type: HostListener, args: ['dragstart', ['$event'], ] },],
'onDragEnd': [{ type: HostListener, args: ['dragend', ] },],
};
}

function DragDirective_tsickle_Closure_declarations() {
/** @type {?} */
DragDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragDirective.ctorParameters;
/** @type {?} */
DragDirective.propDecorators;
/** @type {?} */
DragDirective.prototype.draggedItem;
/** @type {?} */
DragDirective.prototype.cssHighlight;
/** @type {?} */
DragDirective.prototype.releaseDrop;
/** @type {?} */
DragDirective.prototype.startDrag;
/** @type {?} */
DragDirective.prototype.highlighted;
/** @type {?} */
DragDirective.prototype.dropSubscription;
/** @type {?} */
DragDirective.prototype.el;
/** @type {?} */
DragDirective.prototype.dragDropDirectiveService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
